import type { SpaceOverlayIntent } from '@toolproof-core/visualization/runtime/_contract/overlay';

import { resolveModeIntent } from '@/workflow/modes/_@shared/_pure/modeOverlay';
import type { AdapterMode } from '@/workflow/_contract/mode';

export function reduceModeIntent<TRuntimeState extends { adapterMode: AdapterMode }>(args: {
    runtimeState: TRuntimeState;
    intent: SpaceOverlayIntent;
    createRuntimeStateByMode: Record<AdapterMode, () => TRuntimeState>;
}): TRuntimeState | undefined {
    const nextMode = resolveModeIntent(args.intent);
    if (nextMode === undefined) return undefined;
    if (nextMode === args.runtimeState.adapterMode) return args.runtimeState;

    return args.createRuntimeStateByMode[nextMode]();
}
